import React, {PureComponent, Fragment} from "react";
import styled, { css, keyframes } from 'styled-components';


import Odometer from "react-odometerjs";
import "odometer/themes/odometer-theme-default.css";
import "./CircleProgressBar.css";



/**
 * @desc Reports CircleProgressBar Diplaying component
 * @param props
 * @return null
 * @author Praveen George,Jamshith
 */
class CircleProgressBar extends PureComponent {
    render()  {
        return (
            <Fragment>
                <div className={"card-item second-row " + this.props.className}>
                    <h6>{this.props.title}</h6>
                    <div className="flex-wrapper">
                        <svg viewBox="0 0 36 36" className="circular-chart">
                            <filter id="blur-filter">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="0.4" />
                            </filter>
                            <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                            <path className={"circle " + (this.props.processedCount === 100 ?"circle-glow": this.props.strokeDashArray === 0 ?"circle-glow": "circle-glow circle-animate circle-fill")} fill="none" stroke-dasharray={this.props.strokeDashArray + ", 100"} stroke={this.props.stroke} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                            <path className={"circle " + (this.props.processedCount === 100 ?"": this.props.strokeDashArray === 0 ? "" : "circle-animate circle-fill") } stroke={this.props.strokeColor} stroke-dasharray={this.props.strokeDashArray + ", 100"} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>	    	
                            <defs>
                                <linearGradient id={this.props.linearGradientColor} gradientUnits="objectBoundingBox" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stop-color={this.props.stopColorStart} />
                                    <stop offset="100%" stop-color={this.props.stopColorEnd} />
                                </linearGradient>
                            </defs>
                        </svg>
                        <span className="text">
                            <span id="progressCandidate" className={this.props.processedCount < 200 ? "hide-count-digit": '' }>
                                <Odometer 
                                    format="d" 
                                    duration={1000} 
                                    value={this.props.processedCount} 
                                />
                            </span> <br></br><span>out of </span>
                            <span className={this.props.totalCount < 200 ? "hide-count-digit": ''}>
                                <Odometer 
                                    format="d" 
                                    duration={1000} 
                                    value={this.props.totalCount} 
                                />
                            </span>
                        </span>
                    </div>
                </div>
            </Fragment>
        );
    }
};

export default CircleProgressBar;



// WEBPACK FOOTER //
// ./src/components/UI/ReportsComponents/CircleProgressBar/CircleProgressBar.js